import { Image } from '@busybusy/webapp-react-ui';
import {
  HeavyEquipmentIcon1,
  HeavyEquipmentIcon10,
  HeavyEquipmentIcon11,
  HeavyEquipmentIcon12,
  HeavyEquipmentIcon13,
  HeavyEquipmentIcon14,
  HeavyEquipmentIcon15,
  HeavyEquipmentIcon16,
  HeavyEquipmentIcon17,
  HeavyEquipmentIcon18,
  HeavyEquipmentIcon19,
  HeavyEquipmentIcon2,
  HeavyEquipmentIcon20,
  HeavyEquipmentIcon21,
  HeavyEquipmentIcon22,
  HeavyEquipmentIcon23,
  HeavyEquipmentIcon24,
  HeavyEquipmentIcon25,
  HeavyEquipmentIcon26,
  HeavyEquipmentIcon27,
  HeavyEquipmentIcon28,
  HeavyEquipmentIcon29,
  HeavyEquipmentIcon3,
  HeavyEquipmentIcon4,
  HeavyEquipmentIcon5,
  HeavyEquipmentIcon6,
  HeavyEquipmentIcon7,
  HeavyEquipmentIcon8,
  HeavyEquipmentIcon9,
} from 'assets/equipment-icons/heavy-equipment';
import './EquipmentIconRenders.scss';

export interface IHeavyEquipmentIconsProps {
  onClick: (icon: string) => void;
}

const HeavyEquipmentIcons = (props: IHeavyEquipmentIconsProps) => {
  const { onClick } = props;

  const icons = [
    HeavyEquipmentIcon1,
    HeavyEquipmentIcon2,
    HeavyEquipmentIcon3,
    HeavyEquipmentIcon4,
    HeavyEquipmentIcon5,
    HeavyEquipmentIcon6,
    HeavyEquipmentIcon7,
    HeavyEquipmentIcon8,
    HeavyEquipmentIcon9,
    HeavyEquipmentIcon10,
    HeavyEquipmentIcon11,
    HeavyEquipmentIcon12,
    HeavyEquipmentIcon13,
    HeavyEquipmentIcon14,
    HeavyEquipmentIcon15,
    HeavyEquipmentIcon16,
    HeavyEquipmentIcon17,
    HeavyEquipmentIcon18,
    HeavyEquipmentIcon19,
    HeavyEquipmentIcon20,
    HeavyEquipmentIcon21,
    HeavyEquipmentIcon22,
    HeavyEquipmentIcon23,
    HeavyEquipmentIcon24,
    HeavyEquipmentIcon25,
    HeavyEquipmentIcon26,
    HeavyEquipmentIcon27,
    HeavyEquipmentIcon28,
    HeavyEquipmentIcon29,
  ];

  return (
    <div className="icon-list mt-2">
      {icons.map((icon, index) => (
        <Image src={icon} key={index} className={'selectable-icon'} onClick={() => onClick(icon)} />
      ))}
    </div>
  );
};

export default HeavyEquipmentIcons;
